<template>
  <v-menu
    content-class="rounded-lg"
    open-on-hover
    offset-y
    bottom
    left
    >
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        v-on="on"
        v-bind="attrs"
      >
        {{ icon }}
      </v-icon>
    </template>

    <v-sheet
      max-width="300"
      class="pa-2 rounded-lg"
    >
      <span
        v-html="sanitize(info)"
      />
    </v-sheet>
  </v-menu>
</template>

<script>

import
  GenericFunctionsMixin
from '@/shared/mixins/genericFunctions/genericFunctionsMixin';

export default {
  name: "HintIcon",

  props: {
    info: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      default: "mdi mdi-information-slab-circle-outline",
    }
  },

  mixins: [
    GenericFunctionsMixin,
  ]
}
</script>